import React from 'react';
import { ChatWindow } from '../components/chat/ChatWindow.tsx';

export function ChatPage() {
  return <ChatWindow />;
}
